<template>
    <el-container>
        <el-dialog :title="$t('common.CHANGEPASSWORD')" :before-close="cancelPass" :visible.sync="dialogPwdVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="20%">
            <el-form :model="formPwdInfo" :rules="rules" ref="formPwdInfo" label-width="80px">
                <el-form-item :label="$t('common.OLDPASSWORD')" prop="oldPass">
                    <el-input type="password" v-model="formPwdInfo.oldPass"></el-input>
                </el-form-item>
                <el-form-item :label="$t('common.NEWPASSWORD')" prop="newPass">
                    <el-input type="password" v-model="formPwdInfo.newPass"></el-input>
                </el-form-item>
                <el-form-item :label="$t('common.CONFIRMATION')" prop="confirmPass">
                    <el-input type="password" v-model="formPwdInfo.confirmPass"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirm('formPwdInfo')">{{ $t('common.CONFIRM') }}</el-button>
                <el-button @click="cancelPass">{{ $t('common.CANCAL') }}</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>
<script>
export default {
    props: ['title', 'dialogPwdVisible', 'editItem'],
    created() {
        this.initRegex();
    },
    // 定义变量
    data() {
        let validatePassword = (rule, value, callback) => {
            if (value === '') {
                callback();
            } else {
                if (this.formPwdInfo.confirmPass !== '') {
                    this.$refs.formPwdInfo.validateField('confirmPass');
                }
                callback();
            }
        };
        let validateConfirmPassword = (rule, value, callback) => {
            if (value === '') {
                callback();
            } else if (this.formPwdInfo.newPass !== value) {
                callback(this.$t('error.ERROR_PASSWORD_NOT_EQUAl'));
            } else {
                callback();
            }
        };
        return {
            // 密码表单信息
            formPwdInfo: {
                oldPass: '',
                newPass: '',
                confirmPass: ''
            },
            // 对表单进行数据验证
            rules: {
                oldPass: [{ required: true, message: this.$t('error.ERROR_PASSWORD_NULL'), trigger: 'blur' }, { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' }],
                newPass: [
                    { required: true, message: this.$t('error.ERROR_NEWPASSWORD_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    { validator: validatePassword, trigger: 'blur' }
                ],
                confirmPass: [
                    { required: true, message: this.$t('error.ERROR_CONFIMPASSWORD_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    { validator: validateConfirmPassword, trigger: 'blur' }
                ]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        initRegex() {
            let params = {
                sTag: 'PASSWORD_RULE'
            };
            window.vue.$api.getDictValuesByType(JSON.stringify(params), response => {
                this.passwordRule = response.data.content[0].sCode;
                this.ruleMessage = response.data.content[0].sValue;
                let regx = {
                    pattern: this.passwordRule,
                    message: this.ruleMessage
                };
                this.rules.newPass.push(regx);
            });
        },
        cancelPass() {
            console.log(this.$common.login.username);
            this.$emit('cancelPass');
        },
        confirm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let _this = this;
                    if (this.formPwdInfo.newPass === this.formPwdInfo.confirmPass) {
                        if (this.formPwdInfo.confirmPass === this.formPwdInfo.oldPass) {
                            this.$message(this.$t('error.ERROR_PASSWORD_IDENTICAL'));
                            return;
                        }
                        this.$api.modifyPassword(
                            {
                                sysId: this.$common.systemInfo.systemId,
                                userName: this.$common.login.username,
                                password: this.formPwdInfo.oldPass,
                                newPassword: this.formPwdInfo.newPass
                            },
                            response => {
                                let statusCode = response.data.statusCode;
                                if (statusCode === _this.$common.requestCode.SUCCESS_INFO_CODE) {
                                    _this.cancelPass();
                                    _this.$message(response.data.statusMessage);
                                    sessionStorage.setItem('token', response.data.content);
                                } else if (statusCode === _this.$common.requestCode.ERROR_PASSWORD) {
                                    _this.$message(_this.$t('error.ERROR_OLD_PASSWORD'));
                                } else {
                                    _this.$message(response.data.statusMessage);
                                }
                            }
                        );
                    } else {
                        let error = this.$t('error.ERROR_PASSWORD_FOUND');
                        this.$message(error);
                    }
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
